import { ConfigurationTemplatesService_templateJsonServiceGetVersion } from '@festina/life-general-types/life/hooks/ConfigurationTemplatesService_templateJsonServiceGetVersion'

export const useFetchTemplateVersion =
  ConfigurationTemplatesService_templateJsonServiceGetVersion.useSuspenseQuery
